import { Alert, Button, Snackbar } from "@mui/material";
import React from "react";
import { useState } from "react";
import { Form } from "react-bootstrap";
import LoadingIcon from "../LoadingIcon";

function LoginDetails() {
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [showNotification, setShowNotification] = useState("success");
  const [open, setOpen] = useState(false);
  const vertical = "top";
  const horizontal = "center";
  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    reEnterNewPassword: "",
  });

  const handleChange = (e) => {
    setPasswords((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    const strongPassword = new RegExp(
      "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})"
    );

    if (strongPassword.test(passwords.newPassword)) {
      setLoading(true);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}change/password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token,
          },
          body: JSON.stringify({
            currentPassword: passwords.currentPassword,
            newPassword: passwords.newPassword,
            reEnterNewPassword: passwords.newPassword,
          }),
        }
      );

      const data = await response.json();

      setOpen(true);

      if (data.status === "ok") {
        setShowNotification("success");
        setFeedback(data.message);
      } else {
        setShowNotification("error");
        setFeedback(data.message);
      }

      setTimeout(() => setOpen(false), 4000);

      setPasswords({
        currentPassword: "",
        newPassword: "",
        reEnterNewPassword: "",
      });
    } else {
      setShowNotification("error");
      setFeedback(
        "Password must have at least a uppercase letter, a lowercase letter, a special character, a number and at least 8 characters."
      );
    }

    setLoading(false);
  };

  return (
    <div className="p-2">
      <Snackbar
        open={open}
        autoHideDuration={6000}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert severity={showNotification}>{feedback}</Alert>
      </Snackbar>

      <Form onSubmit={handlePasswordChange}>
        <div className="row">
          <div className="col-lg-6 mb-8">
            <label className="text-sm mb-2">Current Password</label>
            <Form.Control
              required
              onChange={handleChange}
              type="password"
              name="currentPassword"
              value={passwords.currentPassword}
              disabled={loading}
            />
          </div>
          <div className="col-lg-6 mb-8">
            <label className="text-sm mb-2">New Password</label>
            <Form.Control
              required
              onChange={handleChange}
              type="password"
              name="newPassword"
              value={passwords.newPassword}
              disabled={loading}
            />
          </div>
          <div className="col-lg-6 mb-8">
            <label className="text-sm mb-2">Re -Enter New Password</label>
            <Form.Control
              required
              onChange={handleChange}
              disabled={loading}
              type="password"
              name="reEnterNewPassword"
              value={passwords.reEnterNewPassword}
            />
          </div>
        </div>
        <div className="col-lg-10 flex justify-end my-10">
          {loading ? (
            <Button
              sx={{
                "& .MuiCircularProgress-root": {
                  height: "23px !important",
                  width: "23px !important",
                },
              }}
            >
              <LoadingIcon />
            </Button>
          ) : (
            <Button
              type="submit"
              variant="contained"
              className="!bg-[#101010]"
              disabled={
                passwords.newPassword === passwords.reEnterNewPassword
                  ? false
                  : true
              }
            >
              Save
            </Button>
          )}
        </div>
      </Form>
    </div>
  );
}

export default LoginDetails;
